export default __webpack_public_path__ + "static/media/edited-8.805a4e8b.jpg";